import { Intervents } from './intervents';

export class Pages {
  PageNumber: number;
  Intervents: Intervents[] = [];
}
